angular
	.module 'App.Repository'
	.factory 'BundledProductMetadataRepository', [
		'BaseRepository',
		(BaseRepository) ->
			class BundledProductMetadataRepository extends BaseRepository
				@resource = '/bundled_product_metadata'
				@isRestricted = true

			return new BundledProductMetadataRepository
	]
